import React from 'react';

export const DownloadIcon = ({stroke = '#7f7f7f', size = 15, ...props}) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15.5 15.5">
    <path
      d="M148,446.5v.875A2.625,2.625,0,0,0,150.625,450h8.75A2.625,2.625,0,0,0,162,447.375V446.5m-3.5-3.5-3.5,3.5m0,0-3.5-3.5m3.5,3.5V436"
      transform="translate(-147.25 -435.25)"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
